/**
 * Match permesso staff: path esatto o sotto-path della sezione
 * (es. /salon_management → /salon_management/services).
 * Edge: link "/" non deve matchare tutto.
 */
export const isPathAllowed = (pathname, allowedLinks = []) => {
  if (!pathname || !Array.isArray(allowedLinks) || !allowedLinks.length) return false;

  return allowedLinks.some((link) => {
    if (!link) return false;
    if (link === '/') return pathname === '/';
    return pathname === link || pathname.startsWith(`${link}/`);
  });
};
